module.exports = __webpack_public_path__ + "public/images/slider/speaker-4.ed8fa89ea1802f5b6b9bfb2f29c24ec2.jpg";